<template>
  <v-container grid-list-lg>
    <h6>Station {{name}} Dashboard</h6>
    <v-card class="ma-4 elevation-5">
      <v-card-text>
        <v-layout>
          <v-flex lg6 offset-lg3>
            <p class="text-lg-center">station map</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout row wrap>
      <v-flex xs12 lg6>
        <chart></chart>
      </v-flex>
      <v-flex xs12 lg6>
        <chart></chart>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 lg6>
        <chart></chart>
      </v-flex>
      <v-flex xs12 lg6>
        <chart></chart>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Chart from './Chart'

  export default {
    components: { Chart },
    props: ['name'],
  }
</script>

